import { styled, TextField } from '../../base-components';

export const CustomTextField = styled(TextField)<{
    label: string | undefined;
}>(({ theme, label }) => {
    const hasLabel = !!label;
    return {
        '&.MuiFormHelperText-root': {
            position: 'absolute',
            top: '100%',
        },
        '.Mui-error': {
            '&.MuiFormHelperText-root': {
                position: 'absolute',
                top: '100%',
                marginTop: '0px',
                marginInlineStart: theme.spacing(1),
            },
        },
        legend: { width: hasLabel ? 'auto' : 'unset' },
    };
});
